import { render, staticRenderFns } from "./metas-selos-historico.vue?vue&type=template&id=17365a58&scoped=true"
import script from "./metas-selos-historico.vue?vue&type=script&lang=js"
export * from "./metas-selos-historico.vue?vue&type=script&lang=js"
import style0 from "./metas-selos-historico.vue?vue&type=style&index=0&id=17365a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17365a58",
  null
  
)

export default component.exports